<!-- 底部公用组件 -->
<template viewport>
    <div class="footer2">
        <div class="box">
            <ul>
                <li>{{ $t('navbar.customerService') }}</li>
                <li @click="open($event)">{{ $t('navbar.FAQ') }}</li>
                <!-- <li><a href="#">{{ $t('navbar.unsubscribe') }}</a></li>
                <li><a href="#">{{ $t('navbar.contacts') }}</a></li> -->
            </ul>

            <!-- 关于 -->
            <!-- <ul>
                <li>{{ $t('navbar.about') }}</li>
                <li @click="open($event)">{{ $t('navbar.BattenRecruitment') }}</li>
                <li @click="open($event)">{{ $t('navbar.BattenCampus') }}</li>
                <li @click="open($event)">{{ $t('navbar.KungFuGeek') }}</li>
                <li @click.prevent="expertRecruitment" v-throttle="1000">{{$t('navbar.ExpertRecruitment')}}</li>
            </ul> -->

            <ul v-if="storedValue == 'en'">
                <li>Our Products</li>
                <li><a href="https://welfare-en.buttonpie.cn ">ButtonPie Public Welfare</a></li>
            </ul>

            <ul>
                <li>{{ $t('navbar.legislation') }}</li>
                <li @click="open($event)">{{ $t('navbar.PrivacyPolicy') }}</li>
                <li @click="open($event)">{{ $t('navbar.BrowserCachingPolicy') }}</li>
                <li @click="open($event)">{{ $t('navbar.TermsAndConditions') }}</li>
            </ul>

            <!-- 二维码 -->
            <!-- <div class="ios">
                <img src="../../assets/images/scan.jpg" alt="">
                <span>{{ $t('navbar.FabtankMiniProgram') }}</span>
            </div> -->

            <!-- <div class="and">
                <img class="img-android" src="../../assets/images/scan2.jpg" alt="">
                <span>{{ $t('navbar.AndroidVersionDownload') }}</span>
            </div> -->

            <div class="logo">
                <img src="../../assets/images/txbc-block.png" alt="">
                <a href="https://www.fabtank.cn:63277">https://www.fabtank.cn:63277</a>
                <span>{{ $t('navbar.SuICPFor14053618') }}</span>
            </div>

        </div>
    </div>
</template>

<script>
import { footerInfoApi, footerListApi } from '../../api/index'
import  i18nConfig  from '../../i18n/config/zh'
export default {
    data() {
        return {
            visible: false,
            privacy: '',
            privacyEn:'',
            footerName: '',
            footerNameEn: '',
            clickInfo: '',  //点击某个页脚信息
            storedValue:'',    //语言判断
            enable: 0,  // 0 上架   1 下架
        }
    },
    methods: {
        expertRecruitment(){
            this.$router.push('/recruitment');
        },
        open(event){
            // console.log('event',event)
            //根据不同语言状态  获取点击的中文信息  以对应接口中的 footerType类型 获取对应内容
            if(this.storedValue == 'zh'){
                this.clickInfo = event.srcElement.innerHTML
                // console.log("中文状态下的点击信息",this.clickInfo)
            }else if(this.storedValue == 'en'){
                this.clickInfo = event.srcElement.innerHTML
                const navbarObject = typeof i18nConfig.navbar === 'string' ? JSON.parse(i18nConfig.navbar) : i18nConfig.navbar;
                const keys = Object.keys(navbarObject);
                // 遍历对象查找匹配的 key
                for (let key of keys) {
                    if (key === this.clickInfo) {
                        // console.log("这回对不对",navbarObject[key]);
                        this.clickInfo = navbarObject[key]
                        break; // 找到匹配的 key 后退出循环
                    }
                }
                // console.log("英文状态下的点击信息",this.clickInfo)
            }
            this.getFooterList()
            setTimeout(() => {
                if(this.enable == 0){
                    this.openCache()
                }
            }, 500);
        },
        //弹框
        openCache() {
            // const h = this.$createElement('div');
            if(this.storedValue == 'zh'){
                this.$msgbox({
                    title: this.footerName,
                    message: this.$createElement('div', { domProps: { innerHTML: this.privacy } }),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(action => {
                    done();
                });
            }else if(this.storedValue == 'en'){
                this.$msgbox({
                    title: this.footerNameEn,
                    //this.$createElement('div', { style: 'color: aqua' }, [
                    message:  this.$createElement('div', [
                        this.$createElement('div', { domProps: { innerHTML: this.privacyEn } })
                    ]),
                    showCancelButton: true,
                    confirmButtonText: 'confirm',
                    cancelButtonText: 'cancel',
                }).then(action => {
                    done();
                });
            }
        },
        //通过类型查找页脚信息
        async getFooterList() {
            let { data: res } = await footerInfoApi(this.clickInfo);
            // console.log("通过类型查找页脚信息>>>",res)
            if(res.result){
                this.privacy = res.result.footerContent
                this.privacyEn = res.result.footerContentEn
                this.footerName = res.result.footerName
                this.footerNameEn = res.result.footerNameEn
                this.enable = res.result.enable
            }else{
                this.enable = 1
            }
        }

    },
    created(){
        
    },
    mounted() {
        try {
            //浏览器首次加载没有locale，所以加载lang
            this.storedValue = window.localStorage.getItem('locale') || window.localStorage.getItem('lang');
            // console.log("mounted加载", this.storedValue);
        } catch (error) {
            console.error("Error accessing localStorage:", error);
        }
    },
}
</script>

<style lang="scss">
.el-message-box__header{
    padding: 1.9375rem 0.9375rem 0.625rem;
}
.el-message-box {
    width: 800px;
    margin-top: -300px;
    border-radius: 20px;
}
.el-message-box__title{
    width: 100%;
    text-align: center;
    font-size: 24px;
}
.el-message-box__headerbtn{
    font-size: 24px;
}
.el-message-box__content{
    .el-message-box__container{
        font-size: 20px;
        height: 400px;
        overflow: auto;
        padding: 0 50px;
        line-height: 40px;
    }
}
.el-message-box__btns{
    // width: 98%;
    text-align: center;
    .el-button--small{
        font-size: 20px;
        margin: 0 60px;
        width: 35%;
        border-radius: 20px;
    }
}
.el-message-box__close{
    display: none;
}
</style>

<style lang="scss" scoped>
.footer2 {
    width: 100%;
    height: 265px;
    border-top: 1px solid #242424;

    .box {
        width: 1140px;
        height: 178px;
        display: flex;
        // margin-left: 388px;
        margin: auto;
        justify-content: space-between;

        ul {
            // width: 15%;
            min-width: 100px;
            list-style: none;
            margin-top: 43px;
            // margin-right: 8%;

            li {
                margin-bottom: 16px;
                width: 100%;
                font-size: 16px;
                cursor: pointer;

                a {
                    font-size: 16px;
                    color: #3D3D3D;
                    text-decoration: none;
                }

                &:nth-child(1) {
                    margin-bottom: 15px;
                    font-family: 思源黑体;
                    font-size: 20px;
                    font-weight: bold;
                    line-height: normal;
                    letter-spacing: 0em;
                    color: #3D3D3D;
                }
            }
        }

        .ios,
        .and {
            display: flex;
            flex-direction: column;
            align-items: center;


            img {
                width: 110px;
                height: 110px;
                margin: 44px 45px 3px 0;
            }

            .img-android {
                width: 85px;
                height: 85px;
                border: 1px solid #ACAAAB;
                border-radius: 10px;
                padding: 10px;
            }

            span {
                font-size: 16px;
                margin-right: 43px;
            }
        }

        .logo {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            width: 196px;
            height: 125px;
            margin-top: 54px;
            margin-left: 40px;

            img {
                width: 180px;
                height: 38px;
            }

            a {
                text-decoration: none;
                color: #3D3D3D;
                font-size: 16px;
            }

            span {
                font-size: 14px;
            }
        }
    }
}
</style>